<template>
  <div id="full">
    <transition name="appear" mode="out-in">
      <div class="form-editor-container" v-if="loaded">
        <FormEditorHtml :form="form" :emrJson="emrJson" @formUpdated="formUpdated" :isDraft="true" @publishForm="handlePublishForm"/>
      </div>
    </transition>
    <transition name="modal" mode="out-in">
      <PublishDraftModal v-if="modal.id == 'publish-draft'" @closeModal="closeModal" :rows="modal.data.rows" />
    </transition>
  </div>
</template>

<style scoped></style>

<script>
import PublishDraftModal from '@/modals/form-editor/PublishDraftModal.vue';
import FormEditorHtml from '../components/form-editor-html/FormEditorHtml.vue';
import { getPublicJson } from "@/api";

export default {
  name: "FormEditorView",
  data() {
    return {
      form: null,
      loaded: false,
      saved: false,
      emrJson: null,
      modal: { id: '', open: false, data: {} }
    };
  },
  async created() {
    const rows = this.$route.query.rows;
    
    try {
      const rowsJson = JSON.parse(rows);
      this.loaded = false;
      this.form = {
        id: 'abc',
        isUnderReview: false,
        layoutRows: rowsJson
      }
      this.emrJson = await getPublicJson('/emrs/practicefusion.json')
      console.info('Fetched form info from backend', this.form);
    } catch (err) {
      console.error('Failed to fetch form info', err);
    } finally {
      this.loaded = true;
    }
  },
  methods: {
    openModal(id, data) {
      this.modal = { id: id, open: true, data: data }
    },
    closeModal() {
      this.modal = { id: '', open: false, data: {} }
    },
    handlePublishForm(rows) {
      this.openModal('publish-draft', { rows });
    }
  },
  components: { FormEditorHtml, PublishDraftModal },
};
</script>

<style scoped>
.form-editor-container {
  width: 100%;
  height: calc(100% + 80px);
}

.form-editor-container * {
  margin-top: -80px;
}
</style>